import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input-form" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "input-box width-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-text" }, "+63")
], -1)
const _hoisted_4 = { class: "input-box" }
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "input-box" }
const _hoisted_7 = {
  key: 1,
  class: "sms-btn disabled"
}
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "input-box" }
const _hoisted_10 = { class: "suffix-wrap" }

import { ref, reactive, computed, inject, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n'
import md5 from 'js-md5';
import PopupForm from '@/components/PopupForm.vue';
import { resetTradePwd, resetTradePwdOTP } from "@/api"; 


export default {
  __name: 'ResetPassword',
  props: ['phone'],
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const MyToast = inject('myToast')

const { t } = useI18n()
 
const form = reactive({
  password: '',
  verifyCode: '',
})
const showPassword = ref(false)
const coldDownTime = ref(0);
const coldDownInterval = ref(null);

const smsDisabled = computed(() => {
  return false;
})

const submitDisabled = computed(() => {
  return form.password.length < 6 || form.verifyCode.length < 6 || !/^[A-Za-z0-9]{6,12}$/.test(form.password);
})

onUnmounted(() => {
  if(coldDownInterval.value) {
    clearInterval(coldDownInterval.value);
  }
})

const coldDown = () => {
  if (coldDownInterval.value) {
    clearInterval(coldDownInterval.value);
  }
  coldDownInterval.value = setInterval(() => {
    coldDownTime.value = coldDownTime.value - 1;
    if (coldDownTime.value === 0) {
      clearInterval(coldDownInterval.value);
    }
  }, 1000)
}

const sendVerifyCode = () => {
  if (smsDisabled.value) {
    return false;
  }
  resetTradePwdOTP().then(res => {
    coldDownTime.value = 60;
    coldDown();
  });
}

const doSubmit = () => {
  resetTradePwd({
    password: md5(form.password),
    verifyCode: form.verifyCode,
  }).then(res => {
    MyToast({ type: 'success', message: t('notify.operateSuccess') });
    emit('onClose');
  });
}

const inputBlur = (e) => {
  let field = e.target.name
  if (field) {
    form[field] = form[field].replace(/ +/g, '');
  }
}

return (_ctx, _cache) => {
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_button = _resolveComponent("van-button")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createBlock(PopupForm, {
    title: _ctx.$t('user.withdrawPassword'),
    onOnClose: _cache[3] || (_cache[3] = $event => (emit('onClose')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_field, {
              "model-value": __props.phone,
              name: "phone",
              class: "input-field",
              readonly: ""
            }, null, 8, ["model-value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_field, {
              modelValue: form.verifyCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.verifyCode) = $event)),
              name: "verifyCode",
              class: "input-field",
              placeholder: _ctx.$t('placeholder.otp'),
              type: "digit",
              maxlength: "6",
              onBlur: inputBlur,
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          (coldDownTime.value === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`sms-btn ${smsDisabled.value ? 'disabled' : ''}`),
                onClick: sendVerifyCode
              }, _toDisplayString(_ctx.$t('common.send')), 3))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(coldDownTime.value) + _toDisplayString(_ctx.$t('common.second')), 1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_van_field, {
              modelValue: form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((form.password) = $event)),
              name: "password",
              class: "input-field",
              placeholder: _ctx.$t('placeholder.password'),
              type: !showPassword.value ? 'password' : 'text',
              onBlur: inputBlur,
              maxlength: "12",
              clearable: ""
            }, null, 8, ["modelValue", "placeholder", "type"]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createVNode(_component_van_icon, {
                class: "eye-icon",
                name: !showPassword.value ? 'eye-o' : 'closed-eye',
                onClick: _cache[2] || (_cache[2] = $event => (showPassword.value=!showPassword.value))
              }, null, 8, ["name"]), [
                [_directive_audio]
              ])
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_van_button, {
          class: "submit-btn",
          block: "",
          disabled: submitDisabled.value,
          onClick: doSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_audio]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

}